<template>
  <basic-container style="font-family: fangSong;font-weight: bold;">
    <h1>编辑客户档案信息</h1>
    <el-form ref="form" :model="formData" label-width="100px">
      <el-row>
        <el-col :span="12" v-for="item in column" :key="item.prop">
          <el-form-item v-if="!item.hide" :label="item.label">
            <el-input v-if="item.type === 'input'" v-model="formData[item.prop]"></el-input>
            <el-select v-else-if="item.type === 'select'" filterable v-model="formData[item.prop]">
              <el-option v-for="option in item.dicData" :key="option.value" :label="option.label"
                :value="option.value"></el-option>
            </el-select>
            <el-date-picker v-else-if="item.type === 'datetime'" v-model="formData[item.prop]"
              :value-format="item.valueFormat" :format="item.format" type="datetime"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-col :span="24">
        <el-form-item :label="column[17].label">
          <el-upload :multiple="true" action="#" :accept="formData.previousPhotos.accept"
            :file-list="formData.previousPhotos" :http-request="fnUploadWheelsImgs('previousPhotos')"
            :show-file-list="false">
            <div v-if="formData.previousPhotos.length > 0" class="upload-container">
              <div class="upload-item" v-for="describeImg in formData.previousPhotos" :key="describeImg.label">
                <img :src="describeImg.value"
                  style="width: 100px; height: 100px; border: 1px dashed #ccc; border-radius: 6px; text-align: center; line-height: 100px; cursor: pointer;">
                <a style="margin-left: 20px" @click.stop="deleteImg('previousPhotos', describeImg.label)">删除</a>
              </div>
              <div class="el-upload el-upload--car-two"
                style="width: 100px; height: 100px; border: 1px dashed #ccc; border-radius: 6px; text-align: center; line-height: 100px; cursor: pointer;">
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item :label="column[18].label">
          <el-upload :multiple="true" action="#" :accept="formData.midTermPhotos.accept"
            :file-list="formData.midTermPhotos" :http-request="fnUploadWheelsImgs('midTermPhotos')"
            :show-file-list="false">
            <div v-if="formData.midTermPhotos.length > 0" class="upload-container">
              <div class="upload-item" v-for="describeImg in formData.midTermPhotos" :key="describeImg.label">
                <img :src="describeImg.value"
                  style="width: 100px; height: 100px; border: 1px dashed #ccc; border-radius: 6px; text-align: center; line-height: 100px; cursor: pointer;">
                <a style="margin-left: 20px" @click.stop="deleteImg('midTermPhotos', describeImg.label)">删除</a>
              </div>
              <div class="el-upload el-upload--car-two"
                style="width: 100px; height: 100px; border: 1px dashed #ccc; border-radius: 6px; text-align: center; line-height: 100px; cursor: pointer;">
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item :label="column[19].label">
          <el-upload :multiple="true" action="#" :accept="formData.completionPhotos.accept"
            :file-list="formData.completionPhotos" :http-request="fnUploadWheelsImgs('completionPhotos')"
            :show-file-list="false">
            <div v-if="formData.completionPhotos.length > 0" class="upload-container">
              <div class="upload-item" v-for="describeImg in formData.completionPhotos" :key="describeImg.label">
                <img :src="describeImg.value"
                  style="width: 100px; height: 100px; border: 1px dashed #ccc; border-radius: 6px; text-align: center; line-height: 100px; cursor: pointer;">
                <a style="margin-left: 20px" @click.stop="deleteImg('completionPhotos', describeImg.label)">删除</a>
              </div>
              <div class="el-upload el-upload--car-two"
                style="width: 100px; height: 100px; border: 1px dashed #ccc; border-radius: 6px; text-align: center; line-height: 100px; cursor: pointer;">
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
      </el-col>
      <el-col :span="24" class="footers">
        <el-form-item>
          <el-button type="primary" @click="submitForm">修改</el-button>
          <!-- <el-button @click="resetForm">重置</el-button> -->
        </el-form-item>
      </el-col>
    </el-form>
  </basic-container>
</template>

<script>
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
import { findCustomerInfoDetail, updateCustomerInfo } from "@/api/salesCloud/customerFile";
import { resolveUrlPath } from "@/util/util";
export default {
  data() {
    return {
      tableLoading: false,
      formData: {
        initialNumber: '',
        customerName: '',
        customerPhone: '',
        signingTime: '',
        kingDeeNumber: '',
        projectAddress: '',
        signingType: '',
        systemType: '',
        salesman: '',
        signContract: '',
        contractPrice: '',
        constructionScheduling: '',
        progressExplanation: '',
        reporting: '',
        completionTime: '',
        warrantyPeriod: '',
        previousPhotos: [],
        midTermPhotos: [],
        completionPhotos: [],
      },
      column: [
        {
          label: "初期编号",
          prop: "initialNumber",
          type: "input",
          span: 13,
        },
        {
          label: "客户姓名",
          prop: "customerName",
          type: "input",
          span: 13,
        },
        {
          label: "客户电话",
          prop: "customerPhone",
          type: "input",
          span: 13,
        },
        {
          label: "签单时间",
          prop: "signingTime",
          type: "datetime",
          valueFormat: "timestamp",
          format: "yyyy-MM-dd HH:mm:ss",
          span: 13,
        },
        {
          label: "金蝶系统编号",
          prop: "kingDeeNumber",
          type: "input",
          span: 13,
        },
        {
          label: "项目地址",
          placeholder: "请输入详细地址",
          prop: "projectAddress",
          type: "input",
        },
        // 签约类型signing_type
        {
          label: "签约类型",
          prop: "signingType",
          type: "select",
          dicData: DIC.SIGINING_TYPE,
        },
        // 系统类型system_types
        {
          label: "系统类型",
          prop: "systemType",
          type: "select",
          dicData: DIC.SYSTEM_TYPES,
        },
        // salesman业务员
        {
          label: "业务员",
          prop: "salesman",
          type: "input",
        },
        // 是否已经签订合同sign_contract
        {
          label: "是否签订合同",
          prop: "signContract",
          type: "select",
          dicData: DIC.SIGIN_CONTRACT,
        },
        // contract_price合同价格
        {
          label: "合同价格",
          prop: "contractPrice",
          type: "input",
        },
        // 施工进度construction_scheduling
        {
          label: "施工进度",
          prop: "constructionScheduling",
          type: "select",
          dicData: DIC.CONSTRUCTION_SCHEDULING,
        },
        // progress_explanation具体进度阐述
        {
          label: "具体进度阐述",
          prop: "progressExplanation",
          type: "input",
        },
        // 是否报完工reporting
        {
          label: "是否报完工",
          prop: "reporting",
          type: "select",
          dicData: DIC.REPORTING,
        },
        //完工时间completion_time
        {
          label: "完工时间",
          prop: "completionTime",
          type: "datetime",
          valueFormat: "timestamp",
          format: "yyyy-MM-dd HH:mm:ss",
        },
        //质保期warranty_period
        {
          label: "质保期",
          prop: "warrantyPeriod",
          type: "select",
          dicData: DIC.WARRANTY_PERIOD,
        },
        // 备注remarks
        {
          label: "备注",
          prop: "remarks",
          type: "input",
        },
        // 前期照片previousPhotos
        {
          label: "前期照片",
          prop: "previousPhotos",
          type: "upload",
          hide: true,
          accept: "image/jpeg,image/jpg,image/png",
          tip: "只能上传jpg/png文件，且不超过500kb",
        },
        // 中期照片midTermPhotos
        {
          label: "中期照片",
          prop: "midTermPhotos",
          type: "upload",
          hide: true,
          accept: "image/jpeg,image/jpg,image/png",
          tip: "只能上传jpg/png文件，且不超过500kb",
        },
        //完工照片completionPhotos
        {
          label: "完工照片",
          prop: "completionPhotos",
          type: "upload",
          hide: true,
          accept: "image/jpeg,image/jpg,image/png",
        },
      ],
    };
  },
  created() {
    this.getDetail();
  },
  methods: {

    getDetail() {
      this.tableLoading = true;
      findCustomerInfoDetail(this.$route.query.id).then((res) => {
        let data = JSON.parse(res.data);
        for (const prop of Object.keys(this.formData)) {
          if (data.hasOwnProperty(prop)) {
            if (prop.endsWith('Photos')) {
              this.formData[prop] = data[prop].split(',').map((url, index) => ({
                label: `${prop}_${index}`,
                value: url,
              }));
            } else {
              this.formData[prop] = data[prop];
            }
          }
        }
        this.tableLoading = false;
      });
    },
    deleteImg(type, label) {
      // 在这里处理删除图片的逻辑
      // 可以根据 type 删除对应的图片
      // 更新 this.formData[type]
      this.formData[type] = this.formData[type].filter((img) => img.label !== label);
    },
    submitForm() {
      // 提交表单的逻辑
      // 通过 API 将编辑后的数据提交
      // 例如：updateCustomerInfo(this.formData)
      let formData = { ...this.formData };
      // 处理图片数据
      formData.previousPhotos = formData.previousPhotos.map((img) => img.value).join(',');
      formData.midTermPhotos = formData.midTermPhotos.map((img) => img.value).join(',');
      formData.completionPhotos = formData.completionPhotos.map((img) => img.value).join(',');
      formData.id = this.$route.query.id;
      // TODO: 提交表单数据
      console.log(formData);
      // 确认无误后，提交表单
      this.$confirm("确认修改提交？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
      updateCustomerInfo(formData).then(res => {
        this.$message.success('客户档案信息已更新');
        // 重定向到客户档案信息列表页/salesCloud/customerFile
        this.$router.push({ path: resolveUrlPath('/salesCloud/customerFile') });
      });
      })
      .catch(() => {
        // 取消提交表单
        this.$message.info('已取消提交');
      })
    },
    resetForm() {
      // 重置表单
      // 可以重新获取客户档案信息以还原表单数据
      this.getDetail();
    },
    fnUploadWheelsImgs(type) {
      return (option) => {
        // 处理上传图片的逻辑
        // 上传成功后，将信息添加到 this.formData[type]
        // 例如：addCustomerInfo(this.formData)
        getAliyunPublicToken().then((res) => {
          let data = JSON.parse(res.data);
          let client = new oss({
            region: data.point,
            endPoint: data.point,
            accessKeyId: data.accessKeyId,
            accessKeySecret: data.accessKeySecret,
            Expiration: data.expiration,
            bucket: data.bucketName,
            stsToken: data.securityToken,
          });
          const storeAs = md5(option.file.name) + new Date().getTime();

          if (!Array.isArray(this.formData[type])) {
            this.formData[type] = [];
          }

          client
            .multipartUpload(storeAs, option.file, {})
            .then((results) => {
              let res = results.res.requestUrls[0].split("?");
              this.formData[type].push({ label: storeAs, value: res[0] });
            })
            .catch((err) => {
              console.error(err);
            });
        });
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.footers {
  text-align: center;
}

.upload-container {
  display: flex;
  flex-wrap: wrap;
}

.upload-item {
  flex: 0 0 auto;
  margin-right: 10px;
  margin-bottom: 10px;
}

// .el-upload横向布局超出换行
</style>